export default "__VITE_ASSET__b8e18751__"